

let label = "Puesto"

const PuestoLabel = {
  init:(nombreCliente)=>{

    if(nombreCliente.includes("LMJ")){
      label = "Grado"
    }
  },
  getValor : ()=>label
}

export default PuestoLabel